import { useState } from 'react';
import { Tooltip, ClickAwayListener } from '@mui/material';
import { SavedThumbnail } from '../../../../data/atom';
import { ON_KIDS_ANALYSIS_THUMBNAIL } from '../../../../data/define';
import LoadingProgress from '../../../../component/common/LoadingProgress';
import ImgNoThumbnail from '../../../../assets/image/fallback_thumbnail.png';
import IcCircled from '../../../../assets/image/ic_!_circle.svg';
import IcNormal from '../../../../assets/image/intelligence/ic_normal.svg';
import type { AnalysisLocationState } from '../index';

interface AnalysisPendingViewProps {
  savedThumbnail: SavedThumbnail;
  state: AnalysisLocationState | null;
  onNavigateHome: () => void;
}

export default function AnalysisPendingView({
  savedThumbnail,
  state,
  onNavigateHome,
}: AnalysisPendingViewProps) {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <>
      <LoadingProgress open={true} />
      <div className="z-9999 absolute top-3 right-3 text-[white] flex items-center">
        <button
          type="button"
          className="underline"
          onClick={onNavigateHome}
          style={{ color: '#fff' }}
        >
          앱 둘러보기
        </button>
        <ClickAwayListener onClickAway={() => setTooltipOpen(false)}>
          <Tooltip
            open={tooltipOpen}
            onClose={() => setTooltipOpen(false)}
            disableHoverListener
            disableFocusListener
            title={
              <div className="flex flex-col gap-[8px] text-[14px] font-[400] text-[#FFFFFF]">
                <div>분석 중에는 앱을 벗어나지 마세요.</div>
                <div>다른 메뉴는 자유롭게 이용 가능합니다.</div>
              </div>
            }
            arrow
            placement="bottom"
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: '#363636',
                  borderRadius: '12px',
                  padding: '14px',
                  maxWidth: '252px',
                  fontSize: '14px',
                  fontFamily: 'Pretendard',
                  fontWeight: 400,
                  '& .MuiTooltip-arrow': {
                    color: '#363636',
                  },
                },
              },
            }}
          >
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setTooltipOpen(!tooltipOpen);
              }}
            >
              <img src={IcCircled} alt="Icon" className="w-[17px] h-[17px] ml-2" />
            </button>
          </Tooltip>
        </ClickAwayListener>
      </div>
      <div className="z-9999 absolute top-[20%] inset-0 text-center text-[24px] font-[700] text-[#FFFFFF] py-[20px]">
        <div className="leading-[30px]">AI가 아이의 잠재된</div>
        <div className="leading-[30px]">재능을 분석하고 있어요.</div>
      </div>
      <div
        className="z-9999 absolute top-[75%] inset-0 text-center w-[full] mx-[20px] rounded-[10px] h-[50px] text-[13px] px-3 font-[600] leading-[30px] text-[#FFFFFF] flex items-center py-[10px]"
        style={{ background: 'rgba(0, 0, 0, 0.5)' }}
      >
        <img src={IcNormal} alt="Icon" className="w-[19px] h-[21px] mr-2" />
        <span className="break-all leading-[18px] text-left">
          영상에 따라 분석이 최소 5분 정도 소요될 수 있어요!
        </span>
      </div>
      <div className="grow w-full flex flex-col items-center justify-center overflow-hidden">
        <img
          src={
            state?.thumbnail ||
            savedThumbnail?.thumbnail ||
            sessionStorage.getItem(ON_KIDS_ANALYSIS_THUMBNAIL) ||
            ImgNoThumbnail
          }
          alt="Selected"
          className="object-cover max-h-full w-full h-full"
        />
      </div>
    </>
  );
}
